import {
	Box,
	Button,
	Divider,
	FormControl,
	Grid,
	IconButton,
	InputBase,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Typography,
	styled,
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import Draft_logo from '../../../assets/logos/greennotePad.png';

import patientDashboard from '../../../assets/images/patientDashboard.png';

import Rejected_logo from '../../../assets/logos/reject visit logo.png';

import Billed_logo from '../../../assets/logos/billed visit logo.png';

import Skip_logo from '../../../assets/logos/hotpinkChecpad.png';

import OtherAppointment from '../../../assets/logos/OtherAppointment.png';

import AllAppointment from '../../../assets/logos/AllApointment.png';

import Approved_logo from '../../../assets/logos/blue.png';

import './Dashboard.css';

import CloseIcon from '@mui/icons-material/Close';

import Menu from '@mui/material/Menu';

import SearchIcon from '@mui/icons-material/Search';

import WebLogo from '../../../assets/logos/websitelogo.svg';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import Badge from '@mui/material/Badge';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {
	getBatches,
	getLocation,
	getAppointment,
	getPatientList,
	postVisitDatalist,
	getSummaryData,
} from '../../services/api/apiManager';
import { useStateValue } from '../../services/state/State';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { actions } from '../../services/state/Reducer';
import moment from 'moment';
import {
	ActivePatients,
	AllAppointments,
	ApprovedVisits,
	BatchesModalBox,
	BilledVisits,
	DraftVisits,
	RejectedVisits,
} from './DashboardModals';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	height: {
		xl: '70vh',
		md: '50vh',
		lg: '55vh',
		sm: '55vh',
		xs: '55vh',
	},
	width: '60vw',
	overflow: 'auto',
	bgcolor: 'white',
};
export function Dashboard() {
	const navigate = useNavigate();
	const practice_id = localStorage.getItem('practice_id');
	const [patientList, setPatientList] = useState([]);
	const [appointmentList, setAppointmentList] = useState([]);
	const [pendingAppointments, setPendingAppointments] = useState([]);
	const [openDraft, setOpenDraft] = React.useState(false);
	const [openApproved, setOpenApproved] = React.useState(false);
	const [openBilled, setOpenBilled] = React.useState(false);
	const [openRejected, setOpenRejected] = React.useState(false);
	const [openActivePatient, setOpenActivePatient] = React.useState(false);
	const [openAppointments, setOpenAppointments] = React.useState(false);
	const [batchesVisitsModal, setBatchesVisitsModal] = React.useState({
		batchName: '',
		modalOpen: false,
		data: [],
	});
	const [{ user }, dispatch] = useStateValue();

	const [locationId, setLocationId] = useState('');
	const [visits, setVisits] = useState([]);
	const [visitsSummary, setVisitsSummary] = useState([]);
	const [locations, setLocations] = useState([]);
	const [batches, setBatches] = useState([]);
	const [status, setStatus] = useState('');
	const practiceID = localStorage.getItem('practice_id');
	const [toDate, setToDate] = useState(dayjs(new Date()));
	const [fromDate, setFromDate] = useState(
		dayjs(new Date()).subtract(30, 'day')
	);
	// filter the patientList active patient

	const handleChangeStatus = (event) => {
		setStatus(event.target.value);
	};
	const [location, setLocation] = useState('');
	const handleChangeLocation = (event) => {
		setLocation(event.target.value);
	};
	// filter the location summry
	const [locationSummary, setLocationSummary] = useState('');
	const handleChangeLocationSummary = (event) => {
		setLocationSummary(event.target.value);
	};
	// const handleOpen = () => setOpenDraft(true);
	const handleOpen = () => {
		visits?.filter((items) => items?.VisitStatus == 'D')?.length > 0
			? setOpenDraft(true)
			: setOpenDraft(false);
	};
	const handleOpenApproved = () => {
		visits?.filter((items) => items?.VisitStatus == 'A')?.length > 0
			? setOpenApproved(true)
			: setOpenApproved(false);
	};
	const handleOpenBilled = () => {
		visits?.filter((items) => items?.VisitStatus == 'B')?.length > 0
			? setOpenBilled(true)
			: setOpenBilled(false);
	};
	const handleOpenActivePatients = () => {
		setOpenActivePatient(true);
	};
	const handleOpenRejected = () => {
		visits?.filter((items) => items?.VisitStatus == 'O')?.length > 0
			? setOpenRejected(true)
			: setOpenRejected(false);
	};
	const handleOpenAppointments = () => {
		appointmentList?.filter((items) => items?.Status == 'P')?.length > 0
			? setOpenAppointments(true)
			: setOpenAppointments(false);
	};

	// const handleOpenAppointments = () => setOpenAppointments(true);
	const handleCloseModal = () => setOpenDraft(false);
	const handleCloseApproved = () => setOpenApproved(false);
	const handleCloseBilled = () => setOpenBilled(false);
	const handleCloseRejected = () => setOpenRejected(false);
	const handleCloseAppointments = () => setOpenAppointments(false);
	const handleCloseActivePatient = () => setOpenActivePatient(false);

	// const handleOpenBatchesVisitModal = (data, name) => {
	// 	setBatchesVisitsModal({ modalOpen: true, data: data, batchName: name });
	// };
	const handleOpenBatchesVisitModal = (data, name, count) => {
		debugger;
		if (count > 0) {
			setBatchesVisitsModal({ modalOpen: true, data: data, batchName: name });
		}
	};
	const handleCloseBatchesVisitModal = () => {
		setBatchesVisitsModal({ modalOpen: false, data: [] });
	};

	const [loading, setLoading] = useState(true); // State to track loading
	// const [filteredVisitData, setFilteredVisitData] = useState([]);
	const [anchorLoadingEl, setAnchorLoadingEl] = useState(null); // State to track loading

	const [anchorEl, setAnchorEl] = useState(null);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const [anchorBatchEl, setAnchorBatchEl] = useState(null);
	const handleBatchClick = (event) => {
		setAnchorBatchEl(event.currentTarget);
	};
	const handleBatchClose = () => {
		setAnchorBatchEl(null);
	};

	// API Calling
	const [search, setSearch] = useState('');

	// All message Batches
	const getAllBatches = async () => {
		try {
			const response = await getBatches();
			if (response?.status === 200) {
				dispatch({ type: actions.SET_BATCHES, payload: response?.data });
				setBatches(response?.data?.reverse());
			} else {
				dispatch({ type: actions.SET_BATCHES, payload: [] });
				setBatches([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	const getlocations = async () => {
		try {
			const response = await getLocation();
			if (response?.status === 200) {
				dispatch({ type: actions.SET_LOCATIONS, payload: response?.data });
				setLocations(response?.data);
			} else {
				dispatch({ type: actions.SET_LOCATIONS, payload: [] });
				setLocations([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const fetchAppointments = async () => {
		const res = await getAppointment();

		if (res?.status === 200) {
			setAppointmentList(
				res?.data?.filter(
					(items) =>
						items?.Status === 'P' && items?.patient?.practice_id == practice_id
				)
			);
		} else if (res?.status === undefined) {
			setAppointmentList([]);
		}
	};

	// 	// pagination
	// Last 30 day visit
	const [page, setPage] = useState(1); // Set the initial page number
	const [pageSize, setPageSize] = useState(5); // Set the initial page size
	const [pagination, setPagination] = useState(null);

	const paginationMenuOpen = (event) => {
		setPagination(event.currentTarget);
	};

	const paginationMenuClose = () => {
		setPagination(null);
	};
	// filter data
	const filteredVisitData = visits?.filter((item) => {
		if (status === '' && location === '') {
			return true;
		}
		const statusMatch = status === '' || item?.VisitStatus === status;
		const locationMatch = location === '' || item?.location === location;
		return statusMatch && locationMatch;
		// }
	});
	// filter summary location
	const filterLocation = visitsSummary?.filter((item) => {
		const location =
			locationSummary === '' ||
			item?.LocationName?.toLowerCase()?.includes(
				locationSummary.toLowerCase()
			);
		return location;
	});
	const totalItemsVisits = filteredVisitData?.length;
	const totalPagesVisits = Math.ceil(totalItemsVisits / pageSize);

	const startIndex = (page - 1) * pageSize;
	const endIndex = Math.min(startIndex + pageSize, totalItemsVisits);

	const handleChangePageVisits = (newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPageVisits = (size) => {
		setPageSize(size);
		setPage(1); // Reset to first page when changing page size
	};

	// pagination batch
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSizeBatch, setPageSizeBatch] = useState(5);
	// pagination location
	const [currentPageLocation, setCurrentPageLocation] = useState(1);
	const [pageSizeLocation, setPageSizeLocation] = useState(5);

	// Filtered batches based on search query
	const filteredBatchesData = batches?.filter((item) => {
		return (
			item.BatchName &&
			item.BatchName.toLowerCase().includes(search.toLowerCase())
		);
	});

	const totalItems = filteredBatchesData?.length;
	const itemsPerPage = pageSizeBatch;
	const totalPages = Math.ceil(totalItems / itemsPerPage);

	// Calculate the starting index of the current page
	const startIndexBatch = (currentPage - 1) * pageSizeBatch;
	const endIndexBatch = Math.min(
		startIndexBatch + pageSizeBatch,
		filteredBatchesData?.length
	);

	const handleChangePage = (newPage) => {
		setCurrentPage(newPage);
	};

	const handleChangeRowsPerPage = (e) => {
		setPageSizeBatch(e.target.value);
		setCurrentPage(1);
	};

	// Location summary
	const totalItemsLocation = filterLocation?.length;
	const itemsPerPageLocation = pageSizeLocation;
	const totalPagesLocation = Math.ceil(
		totalItemsLocation / itemsPerPageLocation
	);

	// Location summary Calculate the starting index of the current page
	const startIndexLocation = (currentPageLocation - 1) * pageSizeLocation;
	const endIndexLocation = Math.min(
		startIndexLocation + pageSizeLocation,
		filterLocation?.length
	);
	// Location
	const handleChangePageLocation = (newPage) => {
		setCurrentPageLocation(newPage);
	};

	const handleChangeRowsPerPageLocation = (e) => {
		setPageSizeLocation(e.target.value);
		setCurrentPageLocation(1);
	};

	const getAllPatients = async (practice_id) => {
		try {
			const resp = await getPatientList(practice_id);
			if (resp?.status === 200) {
				setPatientList(
					resp?.data
						?.filter(
							(items) => items?.Inactive == null || items?.Inactive == false
						)
						?.reverse()
				);
			} else {
				setPatientList([]);
			}
		} catch (error) {
			console.log(`error->`, error);
		}
	};

	// charge list data

	const getVisitListData = async (data) => {
		try {
			setLoading(true);
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setVisits(response?.data);
			} else {
				setVisits([]);
			}
			setLoading(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoading(false);
		}
	};
	// visit summary
	const getVisitSummary = async (data) => {
		try {
			setLoading(true);
			const response = await getSummaryData(data);
			if (response?.status === 200 || response?.status === 201) {
				setVisitsSummary(response?.data);
			} else {
				setVisitsSummary([]);
			}
			setLoading(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoading(false);
		}
	};

	const filterData = {
		practice_id: practiceID,
	};
	// summary
	const sendData = {
		practiceid: practiceID,
	};

	useEffect(() => {
		getVisitListData(filterData);
		getVisitSummary(sendData);
		fetchAppointments();
		getAllBatches();
		getlocations();
		getAllPatients(practice_id);
	}, [practice_id]);

	const appointmentTypes = [
		{
			status: 'Draft Visits',
			color: '#feab13',
			cardLogoColor: '#E3FFE7',
			logo: Draft_logo,
			count: visits?.filter((items) => items?.VisitStatus === 'D')?.length,
			handleClick: handleOpen,
		},
		{
			status: 'Approved Visits',
			color: '#3EAE4E',
			cardLogoColor: '#E5F0FF',
			logo: Approved_logo,
			count: visits?.filter((items) => items?.VisitStatus === 'A')?.length,
			handleClick: handleOpenApproved,
		},
		// {
		// 	status: 'Other Visits',
		// 	color: '#ED2828',
		// 	cardLogoColor: '#FFCECE',
		// 	logo: OtherAppointment,
		// 	count: visits?.filter((items) => items?.VisitStatus === 'O').length,
		// 	handleClick: handleOpenRejected,
		// },
		{
			status: 'Billed Visits',
			color: '#DB8B44',
			cardLogoColor: '#FFEDDC',
			logo: Billed_logo,
			count: visits?.filter((items) => items?.VisitStatus === 'B').length,
			handleClick: handleOpenBilled,
		},
		{
			status: 'Active Patients',
			color: 'green',
			cardLogoColor: '#E3FFE7',
			logo: patientDashboard,
			count: patientList?.length,
			handleClick: handleOpenActivePatients,
		},
		{
			status: 'Pending Appointments',
			color: '#913EAE',
			cardLogoColor: '#F2ECFE',
			logo: AllAppointment,
			count: appointmentList?.length,
			handleClick: handleOpenAppointments,
		},
	];
	return (
		<Box
			sx={{
				overflowX: 'hidden',
				// bgcolor: '#FBFAFA',
				padding: '8px',
			}}
		>
			{loading ? ( // Display loading indicator if loading is true
				// <div
				// 	style={{
				// 		display: 'flex',
				// 		justifyContent: 'center',
				// 		alignItems: 'center',
				// 		height: '100vh',
				// 	}}
				// >
				// 	{' '}
				// 	<CircularProgress />
				// </div>
				<div className="loading-container">
					<div className="logo-container">
						<img className="logo" src={WebLogo} alt="Website Logo" />
					</div>
				</div>
			) : (
				<Grid container sx={{ gap: '10px' }}>
					{/* Card Visit */}
					<Grid
						container
						// sx={{ display: 'flex', }}
						spacing={1}
					>
						{appointmentTypes.map((appointment, index) => (
							<Grid item lg={2.4} xl={2.4} md={6} sm={6} xs={12} key={index}>
								<Box
									sx={{
										paddingTop: '10px',
										paddingBottom: '10px',
										border: `1px solid ${'#00000026'}`,
										borderRadius: '10px',
										// margin: '3px',
										boxShadow: '0px 1px 6px 0px #0000000F',
									}}
								>
									<Box
										sx={{
											display: 'flex',
											alignItems: 'center',
											gap: '5px',
										}}
									>
										<Divider
											sx={{
												backgroundColor: appointment.color,
												width: '4px',
												// height: '60px',
												height: {
													xl: '80px',
													lg: '60px',
													md: '60px',
													sm: '60px',
													xs: '60px',
												},
											}}
										/>
										<Box sx={{ zIndex: '2' }}>
											<Typography
												sx={{
													color: '#2E476B',
													fontWeight: '400',
													fontFamily: 'Poppins',
													fontSize: {
														xl: '20px',
														lg: '13px',
														md: '13px',
														sm: '13px',
														xs: '20px',
													},
													whiteSpace: 'nowrap',
												}}
											>
												{appointment.status}
											</Typography>
											<Button onClick={appointment.handleClick}>
												<Typography
													variant="h4"
													sx={{
														color: appointment.color,
														fontWeight: 'bold',
														textDecoration: 'underline',
														fontSize: {
															xl: '34px',
															lg: '20px',
															md: '20px',
															sm: '20px',
															xs: '20px',
														},
													}}
												>
													{appointment.count}
												</Typography>
											</Button>
										</Box>
										{/* Visit Card Logo */}
										<CardLogo sx={{ bgcolor: appointment.cardLogoColor }}>
											<Box
												component={'img'}
												src={appointment.logo}
												sx={{
													height: {
														xl: '30px',
														lg: '20px',
														md: '20px',
														sm: '20px',
														xs: '20px',
													},
													width: {
														xl: '25px',
														lg: '15px',
														md: '15px',
														sm: '15px',
														xs: '15px',
													},
												}}
											/>
										</CardLogo>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
					{/* Last 30 day visit, Batches and unread messages portion  */}
					<Grid container spacing={1}>
						{/* Last 30 day visits */}
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<Box
								sx={{
									background: 'white',
									borderRadius: '10px',
									border: '1px solid #00000026',
									padding: '0px 5px',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
											m: '5px',
										}}
									>
										<Box>
											<Typography
												fontWeight={600}
												fontFamily={'Poppins'}
												fontSize={'15px'}
											>
												Last 30 day visits
											</Typography>
										</Box>
										<Box sx={{ display: 'flex', gap: '5px' }}>
											<FormControl
												variant="standard"
												sx={{
													minWidth: 100,
													mt: '-5px',
												}}
											>
												<InputLabel
													sx={{
														ml: '10px',
														fontSize: '14px',
													}}
													id="demo-simple-select-standard-label"
												>
													Status
												</InputLabel>
												<Select
													value={status}
													onChange={handleChangeStatus}
													sx={{
														borderLeft: '6px solid #DA8541',
														borderRadius: '7px',
														'&.MuiInput-underline:before': {
															borderBottom: 'none',
														},
														'&.Mui-focused': {
															'&.MuiInput-underline:before': {
																borderBottom: 'none',
															},
														},
														height: {
															xl: '40px',
															lg: '30px',
															md: '30px',
															xs: '30px',
															sm: '30px',
														},
														width: '100px',
														'& .MuiSelect-select': {
															fontSize: '12px',
															ml: '5px',
														},

														outline: '1px solid #00000026',
													}}
													labelId="demo-simple-select-standard-label"
													id="demo-simple-select-standard"
													label="Status"
													MenuProps={{
														PaperProps: {
															style: {
																overflowX: 'auto',
																maxHeight: '300px',
																width: '130px',
																overflowY: 'auto',
																overflowX: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem
														value={''}
														sx={{
															fontSize: {
																xl: '12px',
																lg: '12px',
																md: '12px',
																xs: '12px',
																sm: '12px',
															},
														}}
													>
														Clear Filter
													</MenuItem>
													<MenuItem
														value={'A'}
														sx={{
															fontSize: '12px',
														}}
													>
														Approved
													</MenuItem>
													<MenuItem
														value={'B'}
														sx={{
															fontSize: '12px',
														}}
													>
														Billed
													</MenuItem>
													<MenuItem
														value={'O'}
														sx={{
															fontSize: '12px',
														}}
													>
														Others
													</MenuItem>
													<MenuItem
														value={'D'}
														sx={{
															fontSize: '12px',
														}}
													>
														Draft
													</MenuItem>
												</Select>
											</FormControl>
											{/* location Drop Down */}
											<FormControl
												variant="standard"
												sx={{
													minWidth: 100,
													mt: '-5px',
												}}
											>
												<InputLabel
													sx={{
														ml: '10px',
														fontSize: '14px',
													}}
													id="demo-simple-select-standard-label"
												>
													Location
												</InputLabel>
												<Select
													value={location}
													onChange={handleChangeLocation}
													sx={{
														borderLeft: '6px solid #DA8541',
														borderRadius: '7px',
														'&.MuiInput-underline:before': {
															borderBottom: 'none',
														},
														'&.Mui-focused': {
															'&.MuiInput-underline:before': {
																borderBottom: 'none',
															},
														},
														height: {
															xl: '40px',
															lg: '30px',
															md: '30px',
															xs: '30px',
															sm: '30px',
														},
														width: '100px',
														'& .MuiSelect-select': {
															fontSize: '12px',
															ml: '5px',
														},

														outline: '1px solid #00000026',
													}}
													labelId="demo-simple-select-standard-label"
													id="demo-simple-select-standard"
													label="Location"
													MenuProps={{
														PaperProps: {
															style: {
																overflowX: 'auto',
																maxHeight: '300px',
																width: '130px',
																overflowY: 'auto',
																overflowX: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem
														value={''}
														sx={{
															fontSize: {
																xl: '12px',
																lg: '12px',
																md: '12px',
																xs: '12px',
																sm: '12px',
															},
														}}
													>
														Clear Filter
													</MenuItem>
													{locations?.map((item) => {
														return (
															<MenuItem
																key={item?.id}
																value={item?.Name}
																sx={{
																	fontSize: {
																		xl: '12px',
																		lg: '12px',
																		md: '12px',
																		xs: '12px',
																		sm: '12px',
																	},
																}}
															>
																{item?.Name}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</Box>
									</Box>
									{/* patient Info */}

									<Box
										sx={{
											height: {
												xl: '55vh',
												lg: '50vh',
												md: '45vh',
												xs: '55vh',
												sm: '55vh',
											},
											overflow: 'auto',
										}}
									>
										{filteredVisitData
											?.slice(startIndex, endIndex)
											?.map((item, index) => {
												// Formatting DOB
												const vDate = new Date(item?.VisitDate);
												const year = vDate.getFullYear();
												const month = (vDate.getMonth() + 1)
													.toString()
													.padStart(2, '0');
												const day = vDate.getDate().toString().padStart(2, '0');
												const formattedvdate = `${year}-${month}-${day}`;
												return (
													<Box
														key={item?.id}
														sx={{
															display: 'flex',
															gap: '15px',
															p: '8px 10px',
															bgcolor: '#F6FAFF',
															border: ' 1px solid #0000001F',
															borderRadius: '6px',
															margin: '5px',
															justifyContent: 'space-between',
														}}
													>
														<Box sx={{ display: 'flex', gap: '6px' }}>
															<Box
																sx={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																	// lineHeight={'22.5px'}
																>
																	Patient Name:{' '}
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			color: '#407BFF',
																			textDecoration: 'underline',
																			cursor: 'pointer',
																		}}
																		onClick={() => {
																			navigate('/editCharge', {
																				state: { pastVisitId: item?.id },
																			});
																		}}
																	>
																		{item?.patient?.Lname}
																		{', '}
																		{item?.patient?.Fname}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Location:
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																		}}
																	>
																		{' ' + `${item?.location}`}
																	</span>
																</Typography>
															</Box>
															<Box
																sx={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<Typography
																	color="#407BFF"
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																></Typography>
															</Box>
														</Box>
														<Box sx={{ display: 'flex', gap: '6px' }}>
															<Box
																sx={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Status:{' '}
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			color:
																				item?.VisitStatus === 'A'
																					? '#076714'
																					: item?.VisitStatus === 'D'
																						? '#FEAB13'
																						: item?.VisitStatus === 'B'
																							? '#FF7E07'
																							: '#C90D0D',
																		}}
																	>
																		{/* {item?.VisitStatus} */}
																		{item?.VisitStatus === 'A'
																			? 'Approved'
																			: item?.VisitStatus === 'B'
																				? 'Billed'
																				: item?.VisitStatus === null
																					? 'Others'
																					: item?.VisitStatus === 'D'
																						? 'Draft'
																						: 'Other'}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																	// lineHeight={'22.5px'}
																>
																	Visit Date: <span>{formattedvdate}</span>
																</Typography>
															</Box>
														</Box>
													</Box>
												);
											})}
										{filteredVisitData.length === 0 && (
											<div
												style={{
													display: 'flex',
													height: '100%',

													alignItems: 'center',
													bgcolor: '#F6FAFF',
													justifyContent: 'center',
												}}
											>
												No Records Found
											</div>
										)}
									</Box>
								</Box>

								{/* Patients Visit Pagination */}
								<Box
									display={'flex'}
									alignItems={'center'}
									justifyContent={'flex-end'}
									sx={{ padding: '5px 10px', gap: '5px' }}
								>
									<span
										style={{
											marginRight: '2px',
											fontSize: '12px',
										}}
									>
										Rows per page:
									</span>
									<Select
										value={pageSize}
										onChange={(e) =>
											handleChangeRowsPerPageVisits(e.target.value)
										}
										displayEmpty
										size="small"
										sx={{
											fontSize: {
												xl: '15px',
												lg: '10px',
												md: '10px',
												xs: '10px',
												sm: '10px',
											},
										}}
									>
										{[
											filteredVisitData?.length > 5 && 5,
											filteredVisitData?.length > 10 && 10,
											filteredVisitData?.length > 25 && 25,
											filteredVisitData?.length > 50 && 50,
											filteredVisitData?.length > 100 && 100,
											filteredVisitData?.length,
										].map((option) => {
											if (option != false) {
												return (
													<MenuItem key={option} value={option}>
														{option}
													</MenuItem>
												);
											}
										})}
									</Select>
									{/* <span>{`${startIndex + 1}–${endIndex} of ${totalItemsVisits}`}</span> */}
									<span
										style={{
											fontSize: '12px',
										}}
									>{`${totalItemsVisits > 0 ? startIndex + 1 : 0}–${endIndex} of ${totalItemsVisits}`}</span>

									<IconButton
										sx={{ color: 'lightblue' }}
										onClick={() => handleChangePageVisits(page - 1)}
										disabled={page === 1}
									>
										<ArrowBackIosNewIcon
											style={{ cursor: 'pointer', marginRight: '20px' }}
											fontSize="10px"
										/>
									</IconButton>
									<IconButton
										sx={{ color: 'lightblue' }}
										onClick={() => handleChangePageVisits(page + 1)}
										disabled={
											page === totalPagesVisits || totalPagesVisits === 0
										}
									>
										<ArrowForwardIosIcon
											style={{ cursor: 'pointer' }}
											fontSize="10px"
										/>
									</IconButton>
								</Box>
							</Box>
						</Grid>
						{/* Batches */}
						{/* <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
							<Box
								sx={{
									background: 'white',
									borderRadius: '10px',
									border: '1px solid #00000026',
									padding: '5px',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										flexDirection: 'column',
										// gap: '10px',
									}}
								>
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
											m: '5px',
										}}
									>
										<Box>
											<Typography
												fontWeight={600}
												fontFamily={'Poppins'}
												fontSize={'19px'}
												lineHeight={'28.5px'}
											>
												Batches
											</Typography>
										</Box>
										<Box sx={{ width: '250px' }}>
											<Search
												value={search}
												onChange={(e) => setSearch(e.target.value)}
												sx={{
													bgcolor: 'whitesmoke',
													boxShadow: 'none',
													border: '1px solid #00000030',
													borderRadius: '6px',
													fontSize: {
														xl: '15px',
														lg: '10px',
														md: '10px',
														xs: '10px',
														sm: '10px',
													},
													height: {
														xl: '40px',
														lg: '30px',
														md: '30px',
														xs: '30px',
														sm: '30px',
													},
												}}
											>
												<SearchIconWrapper>
													<SearchIcon />
												</SearchIconWrapper>
												<StyledInputBase
													placeholder="Search by Batch Name"
													inputProps={{ 'aria-label': 'search' }}
													sx={{
														fontSize: {
															xl: '15px',
															lg: '10px',
															md: '10px',
															xs: '10px',
															sm: '10px',
														},
														height: {
															xl: '40px',
															lg: '30px',
															md: '30px',
															xs: '30px',
															sm: '30px',
														},
													}}
												/>
											</Search>
										</Box>
									</Box>

									<Box
										sx={{
											height: {
												xl: '55vh',
												lg: '50vh',
												md: '45vh',
												xs: '55vh',
												sm: '55vh',
											},
											overflow: 'auto',
										}}
									>
										{filteredBatchesData
											?.slice(startIndexBatch, endIndexBatch)
											.map((item, index) => {
												return (
													<Box
														key={index}
														sx={{
															display: 'flex',
															gap: '15px',
															p: '8px 10px',
															bgcolor: '#F6FAFF',
															border: ' 1px solid #0000001F',
															borderRadius: '6px',
															margin: '5px',
															justifyContent: 'space-between',
														}}
													>
														<Box
															sx={{
																display: 'flex',
																gap: '4px',
																width: '300px',
															}}
														>
															<Box
																sx={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																	// width: '120px'
																}}
															>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																	// lineHeight={'22.5px'}
																>
																	Batch Name:{' '}
																	<span
																		onClick={() => {
																			const singleVisitByBatchID =
																				visits?.filter(
																					(items) => items?.batch_id == item?.id
																				);
																			handleOpenBatchesVisitModal(
																				singleVisitByBatchID,
																				item?.BatchName,
																				item?.num_visits
																			);
																		}}
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '15px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			color: '#407BFF',
																			textDecoration: 'underline',
																			cursor: 'pointer',
																		}}
																	>
																		{item?.BatchName}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																	// lineHeight={'22.5px'}
																>
																	Created Date:
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '15px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			color: '#407BFF',
																		}}
																	>
																		{dayjs(item?.CreatedDate).format(
																			'MM-DD-YYYY'
																		)}
																	</span>
																</Typography>
															</Box>
														</Box>
														<Box
															sx={{
																display: 'flex',
																gap: '6px',
																// width: '150px',
															}}
														>
															<Box
																sx={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																	// lineHeight={'22.5px'}
																>
																	Status:{' '}
																	<span
																		style={
																			item?.BatchStatus === 'P'
																				? { color: '#CBC311' }
																				: item?.BatchStatus === 'E'
																					? { color: '#0F7D1D' }
																					: { color: 'Red' }
																		}
																		// style={{
																		// 	fontFamily: 'Poppins',
																		// 	fontSize: '13px',
																		// 	color: '#407BFF',
																		// }}
																	>
																		{item?.BatchStatus === 'E'
																			? 'Exported'
																			: 'Pending'}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																	// lineHeight={'22.5px'}
																>
																	Charges:{' '}
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '15px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			color: '#036210',
																		}}
																	>
																		{item?.num_visits}
																	</span>
																</Typography>
															</Box>
														</Box>
													</Box>
												);
											})}
										{filteredBatchesData.length === 0 && (
											<div
												style={{
													display: 'flex',
													height: '100%',

													alignItems: 'center',
													bgcolor: '#F6FAFF',
													justifyContent: 'center',
												}}
											>
												No Records Found
											</div>
										)}
									</Box>
								</Box>

								<Grid
									item
									xl={12}
									xs={12}
									lg={12}
									md={12}
									sm={12}
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'flex-end',
										padding: '5px 10px',
										gap: '5px',
									}}
								>
									<span
										style={{
											marginRight: '2px',
											fontSize: '12px',
										}}
									>
										Rows per page:
									</span>
									<Select
										value={pageSizeBatch}
										onChange={handleChangeRowsPerPage}
										displayEmpty
										size="small"
										sx={{
											fontSize: {
												xl: '15px',
												lg: '10px',
												md: '10px',
												xs: '10px',
												sm: '10px',
											},
										}}
									>
										{[5, 25, 50, 100, filteredBatchesData?.length].map(
											(option) => (
												<MenuItem key={option} value={option}>
													{option}
												</MenuItem>
											)
										)}
									</Select>
									<span
										style={{
											fontSize: '12px',
										}}
									>{`${totalItems > 0 ? startIndexBatch + 1 : 0}–${endIndexBatch} of ${totalItems}`}</span>

									<IconButton
										sx={{ color: 'lightblue' }}
										onClick={() => handleChangePage(currentPage - 1)}
										disabled={currentPage === 1}
									>
										<ArrowBackIosNewIcon
											style={{ cursor: 'pointer', marginRight: '20px' }}
											fontSize="10px"
										/>
									</IconButton>
									<IconButton
										sx={{ color: 'lightblue' }}
										onClick={() => handleChangePage(currentPage + 1)}
										disabled={currentPage === totalPages || totalPages === 0}
									>
										<ArrowForwardIosIcon
											style={{ cursor: 'pointer' }}
											fontSize="10px"
										/>
									</IconButton>
								</Grid>
							</Box>
						</Grid> */}
						{/* Visit Summary or location vise data*/}
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<Box
								sx={{
									background: 'white',
									borderRadius: '10px',
									border: '1px solid #00000026',
									padding: '0px 5px',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									{/* header visits summary */}
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
											m: '5px',
										}}
									>
										<Box>
											<Typography
												fontWeight={600}
												fontFamily={'Poppins'}
												fontSize={'15px'}
												lineHeight={'28.5px'}
											>
												Location Wise Summary
											</Typography>
										</Box>
										<FormControl
											variant="standard"
											sx={{
												mt: '-5px',
												minWidth: 100,
											}}
										>
											<InputLabel
												sx={{
													ml: '10px',
													fontSize: '14px',
												}}
												id="demo-simple-select-standard-label"
											>
												Location
											</InputLabel>
											<Select
												value={locationSummary}
												onChange={handleChangeLocationSummary}
												sx={{
													borderLeft: '6px solid #DA8541',
													borderRadius: '7px',
													'&.MuiInput-underline:before': {
														borderBottom: 'none',
													},
													'&.Mui-focused': {
														'&.MuiInput-underline:before': {
															borderBottom: 'none',
														},
													},
													height: {
														xl: '40px',
														lg: '30px',
														md: '30px',
														xs: '30px',
														sm: '30px',
													},
													width: '100px',
													'& .MuiSelect-select': {
														fontSize: '12px',
														ml: '5px',
													},

													outline: '1px solid #00000026',
												}}
												labelId="demo-simple-select-standard-label"
												id="demo-simple-select-standard"
												label="Location"
												MenuProps={{
													PaperProps: {
														style: {
															overflowX: 'auto',
															maxHeight: '300px',
															width: '130px',
															overflowY: 'auto',
															overflowX: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
											>
												<MenuItem
													value={''}
													sx={{
														fontSize: {
															xl: '12px',
															lg: '12px',
															md: '12px',
															xs: '12px',
															sm: '12px',
														},
													}}
												>
													Clear Filter
												</MenuItem>
												{visitsSummary?.map((item, key) => {
													return (
														<MenuItem
															key={key}
															value={item?.LocationName}
															sx={{
																fontSize: {
																	xl: '12px',
																	lg: '12px',
																	md: '12px',
																	xs: '12px',
																	sm: '12px',
																},
															}}
														>
															{item?.LocationName}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Box>
									{/* body visit summary */}
									<Box
										sx={{
											height: {
												xl: '55vh',
												lg: '50vh',
												md: '45vh',
												xs: '55vh',
												sm: '55vh',
											},
											overflow: 'auto',
										}}
									>
										{filterLocation
											?.slice(startIndexLocation, endIndexLocation)
											?.map((item, index) => {
												return (
													<Box
														key={index}
														sx={{
															display: 'flex',
															gap: '15px',
															p: '8px 10px',
															bgcolor: '#F6FAFF',
															border: ' 1px solid #0000001F',
															borderRadius: '6px',
															margin: '5px',
															justifyContent: 'space-between',
														}}
													>
														<Box
															sx={{
																display: 'flex',
																gap: '6px',
															}}
														>
															<Box
																sx={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Location Name:
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},

																			marginLeft: '5px',
																			fontWeight: '600',
																		}}
																	>
																		{item?.LocationName}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Active Patients:
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			fontWeight: 600,
																			color: 'green',
																			marginLeft: '5px',
																		}}
																	>
																		{item?.ActivePatients}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Upcoming Appointments:
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			fontWeight: 600,
																			marginLeft: '5px',
																		}}
																	>
																		{item?.UpcomingAppointments}
																	</span>
																</Typography>
															</Box>
														</Box>
														<Box
															sx={{
																display: 'flex',
																gap: '6px',
															}}
														>
															<Box
																sx={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Draft Visits
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			fontWeight: 600,
																			color: '#feab13',
																			marginLeft: '5px',
																		}}
																	>
																		{' ' + `${item?.DraftVisits}`}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Approved Visits
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			fontWeight: 600,
																			color: '#3EAE4E',
																			marginLeft: '5px',
																		}}
																	>
																		{' ' + `${item?.ApprovedVisits}`}
																	</span>
																</Typography>
																<Typography
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '14px',
																			lg: '10px',
																			md: '10px',
																			xs: '10px',
																			sm: '10px',
																		},
																	}}
																>
																	Billed Visits
																	<span
																		style={{
																			fontFamily: 'Poppins',
																			fontSize: {
																				xl: '14px',
																				lg: '10px',
																				md: '10px',
																				xs: '10px',
																				sm: '10px',
																			},
																			fontWeight: 600,
																			color: '#DB8B44',
																			marginLeft: '5px',
																		}}
																	>
																		{' ' + `${item?.BilledVisits}`}
																	</span>
																</Typography>
															</Box>
														</Box>
													</Box>
												);
											})}
									</Box>
								</Box>
								{/* pagination visit summary */}
								<Grid
									item
									xl={12}
									xs={12}
									lg={12}
									md={12}
									sm={12}
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'flex-end',
										padding: '5px 10px',
										gap: '5px',
									}}
								>
									<span
										style={{
											marginRight: '2px',
											fontSize: '12px',
										}}
									>
										Rows per page:
									</span>
									<Select
										value={pageSizeLocation}
										onChange={handleChangeRowsPerPageLocation}
										displayEmpty
										size="small"
										sx={{
											fontSize: {
												xl: '15px',
												lg: '10px',
												md: '10px',
												xs: '10px',
												sm: '10px',
											},
										}}
									>
										{[
											filterLocation?.length > 5 && 5,
											filterLocation?.length > 10 && 10,
											filterLocation?.length > 25 && 25,
											filterLocation?.length > 50 && 50,
											filterLocation?.length > 100 && 100,
											filterLocation?.length,
										]?.map((option) => {
											if (option != false) {
												return (
													<MenuItem key={option} value={option}>
														{option}
													</MenuItem>
												);
											}
										})}
									</Select>
									<span
										style={{
											fontSize: '12px',
										}}
									>{`${totalItemsLocation > 0 ? startIndexLocation + 1 : 0}–${endIndexLocation} of ${totalItemsLocation}`}</span>

									<IconButton
										sx={{ color: 'lightblue' }}
										onClick={() =>
											handleChangePageLocation(currentPageLocation - 1)
										}
										disabled={currentPageLocation === 1}
									>
										<ArrowBackIosNewIcon
											style={{ cursor: 'pointer', marginRight: '20px' }}
											fontSize="10px"
										/>
									</IconButton>
									<IconButton
										sx={{ color: 'lightblue' }}
										onClick={() =>
											handleChangePageLocation(currentPageLocation + 1)
										}
										disabled={
											currentPageLocation === totalPagesLocation ||
											totalPagesLocation === 0
										}
									>
										<ArrowForwardIosIcon
											style={{ cursor: 'pointer' }}
											fontSize="10px"
										/>
									</IconButton>
								</Grid>
							</Box>
						</Grid>
					</Grid>
				</Grid>
			)}
			{/* Data modal */}
			<Modal
				open={
					openApproved ||
					openRejected ||
					openAppointments ||
					openBilled ||
					openDraft ||
					openActivePatient ||
					batchesVisitsModal?.modalOpen
				}
				onClose={
					openApproved
						? handleCloseApproved
						: openRejected
							? handleCloseRejected
							: openAppointments
								? handleCloseAppointments
								: openBilled
									? handleCloseBilled
									: openDraft
										? handleCloseModal
										: openActivePatient
											? handleCloseActivePatient
											: batchesVisitsModal?.modalOpen
												? handleCloseBatchesVisitModal
												: ''
				}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						sx={{
							width: '100%',
							height: '30px',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							backgroundColor: '#0E4374',
							// position: 'fixed',
							top: 0,
						}}
					>
						<Box color={'whitesmoke'}>
							<Typography
								sx={{
									ml: 2,
									fontFamily: 'Poppins',
									fontWeight: '450',
									fontSize: '13px',
								}}
							>
								{openApproved
									? 'Approved Visits Record'
									: openRejected
										? 'Other Visits Record'
										: openAppointments
											? 'Appointment Records'
											: openBilled
												? 'Billed Visits Record'
												: openDraft
													? 'Draft Visits Record'
													: openActivePatient
														? 'Active Patients'
														: batchesVisitsModal?.modalOpen
															? batchesVisitsModal?.batchName
															: ''}
							</Typography>
						</Box>
						<CloseIcon
							fontSize="small"
							onClick={
								openApproved
									? handleCloseApproved
									: openRejected
										? handleCloseRejected
										: openAppointments
											? handleCloseAppointments
											: openBilled
												? handleCloseBilled
												: openDraft
													? handleCloseModal
													: openActivePatient
														? handleCloseActivePatient
														: batchesVisitsModal?.modalOpen
															? handleCloseBatchesVisitModal
															: ''
							}
							sx={{ cursor: 'pointer', color: 'whitesmoke' }}
						/>
					</Box>
					{openDraft &&
						visits?.filter((items) => items?.VisitStatus === 'D').length >
							0 && (
							<DraftVisits
								draftVisitsDataProp={visits?.filter(
									(items) => items?.VisitStatus === 'D'
								)}
							/>
						)}
					{openApproved &&
						visits?.filter((items) => items?.VisitStatus === 'A').length >
							0 && (
							<ApprovedVisits
								approvedVisitsDataProp={visits?.filter(
									(items) => items?.VisitStatus === 'A'
								)}
							/>
						)}
					{openBilled &&
						visits?.filter((items) => items?.VisitStatus === 'B').length >
							0 && (
							<BilledVisits
								billedvisitsDataProp={visits?.filter(
									(items) => items?.VisitStatus === 'B'
								)}
							/>
						)}
					{openActivePatient && (
						<ActivePatients activePatientDataProp={patientList} />
					)}
					{openAppointments && appointmentList?.length > 0 && (
						<AllAppointments appointmentsDataProp={appointmentList} />
					)}
					{batchesVisitsModal?.modalOpen &&
						batchesVisitsModal?.data?.length > 0 && (
							<BatchesModalBox
								batchesVisitDataProp={batchesVisitsModal?.data}
							/>
						)}
				</Box>
			</Modal>
		</Box>
	);
}

// Styling
// Custom styled components
const CardLogo = styled(Box)(({ theme }) => ({
	width: '45px',
	height: '45px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	marginLeft: 'auto',
	marginRight: '10px',
	borderRadius: '50%',
}));
